import 'lazysizes'
import { addScript } from 'js/mobile/common/intersection-loader-script'

const $header = document.querySelector('.header')

if (document.referrer.split('.')[1] == "r7" ) {
  // Fix the header when we're using a partnership bar
  const headerObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
        if (!entry.isIntersecting && entry.boundingClientRect.x === 0) {
          $header.classList.add('header--with-fixed-partner-bar--fixed', 'mpl__header--with-fixed-partner-bar--fixed')
          return
        }
    
        $header.classList.remove('header--with-fixed-partner-bar--fixed', 'mpl__header--with-fixed-partner-bar--fixed')
    })
  }, {
    threshold: 1
  })

  const $headerPlaceholder = document.querySelector('.mpl__header--placeholder');

  headerObserver.observe($headerPlaceholder);
} else {
  $header.classList.add('header--with-fixed-partner-bar--fixed', 'mpl__header--with-fixed-partner-bar--fixed')
}

const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach((entry) => {
    if (!entry.isIntersecting) {
      import('js/mobile/common/cookie-consent.js')

      const $webpushProvider = document.getElementById('webpush-provider')

      if ($webpushProvider.value === 'webpushr') {
        addScript('webpushr', 'webpushr-jssdk')
      } else {
        addScript($webpushProvider.value)
      }
      
      return
    }
  })
}, {
  rootMargin: '600px'
});

const $btf = document.querySelector('.mpl__header--placeholder')

observer.observe($btf)